<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<p class="edit"><span class="bold">Dictionary of Aphrodisiacs</span></p>
<p class="aut">Harry E. Wedeck</p>
<div class="img_container1">
<img alt="image" src="images/Philosophical_Library_logo.jpg"/>
</div>
<a id="page_4"></a>
<a id="page_5"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?8e311c80